
<template>
  <!--编辑门禁设备-->
  <div class="advanced-form">
    <a-form :form="form" layout="vertical">
      <div class="card">
        <div class="card-head">
          <h3>基本信息</h3>
        </div>
        <div class="card-body">
          <a-row type="flex" justify="space-between">
            <a-col v-for="(item, index) of deviceInfoList" :key="index" v-bind="$store.state.advanced_colWidth">
              <a-form-item v-if="item.label === '设备名称'" :label="item.label">
                <a-input v-decorator="['door_eq_name', formOptions.door_eq_name]" placeholder="请输入设备名称"/>
              </a-form-item>

              <a-form-item v-else-if="item.label === '设备编码'" :label="item.label">
                <span class="ant-form-text">{{item.value}}</span>
                <a-button @click="openModal" type="link">替换</a-button>
              </a-form-item>

              <a-form-item v-else :label="item.label">
                <span class="ant-form-text">{{item.value}}</span>
              </a-form-item>
            </a-col>
          </a-row>
        </div>
      </div>

      <div class="card">
      <div class="card-head">
        <h3>运行参数</h3>
      </div>
      <div class="card-body">
        <a-row type="flex" :gutter="24">
          <a-col v-for="(item, index) of functionList" :key="index" v-bind="$store.state.advanced_colWidth">
            <a-form-item class="dev-param-select" v-if="item.inputType==='select'" :label="item.label" :extra="item.extra" has-feedback>
              <a-select
                v-decorator="item.props"
                allowClear
                showSearch
                :filterOption="filterOption"
                :placeholder="item.placeholder">
                <a-select-option v-for="(el, order) of item.options" :key="order" :value="el.value">
                  {{el.label}}
                </a-select-option>
              </a-select>
            </a-form-item>

            <a-form-item v-if="item.inputType==='input'" :label="item.label" :extra="item.extra" has-feedback>
              <a-input-number v-decorator="item.props" :placeholder="item.placeholder" :min="item.min" :max="item.max"/>
            </a-form-item>

            <a-form-item v-if="item.inputType==='switch'" :label="item.label" :extra="item.extra">
              <a-switch v-decorator="item.props" checkedChildren="开" unCheckedChildren="关"/>
            </a-form-item>
          </a-col>
        </a-row>
      </div>
    </div>
    </a-form>

    <x-toolbar :toolBarList="toolBarList" :btnLoading="btnLoading"></x-toolbar>

    <!--修改设备编码的弹窗-->
    <a-modal
      title="编辑设备编码"
      :visible="visible"
      @ok="changeSnCode"
      @cancel="visible=false"
      okText="确认"
      cancelText="取消"
      destroyOnClose
      :width="800"
      centered
      :maskClosable="false"
      :keyboard="false"
    >
      <a-form :form="snCodeForm">
      <a-form-item label="设备编码" v-bind="$store.state.modal_ItemLayout">
        <a-input v-decorator="['device_sncode', formOptions.device_sncode]" placeholder="请输入设备编码"/>
      </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
import mixin from '../../../js/mixins';
export default {
  mixins: [mixin.inputSearch],
  name: 'editSmartDoor',
  data () {
    return {
      visible: false,
      snCode: '',
      btnLoading: { loading: false },
      actionList: [],
      functionList: [],
      toolBarList: [
        {text: '取消', handle: (item) => this.$router.go(-1), key: 'cancel'},
        {text: '提交', handle: (item) => this.handleSubmit(), type: 'primary', loading: true, key: 'submit'}
      ],
      formOptions: {
        door_eq_name: {
          validateTrigger: 'blur',
          rules: [
            {required: true, message: '请输入设备名称'},
            {min: 2, max: 20, message: '设备名称为2-20个字'}
          ]
        },
        device_sncode: {
          validateTrigger: 'blur',
          rules: [
            {required: true, message: '请输入设备编码'},
            {min: 2, max: 20, message: '设备编码为2-20个字'}
          ]
        }
      },
      deviceInfoList: [
        {key: 'community_name', label: '小区', value: ''},
        {key: 'position_name', label: '位置', value: ''},
        {key: 'device_name', label: '设备名称', value: ''},
        {key: 'factory', label: '设备厂家', value: ''},
        {key: 'product_type', label: '产品型号', value: ''},
        {key: 'device_sncode', label: '设备编码', value: ''}
      ]
    };
  },
  beforeCreate () {
    this.form = this.$form.createForm(this); // 实例对象下$form方法通过createForm方法创建表单，并赋值给this.form
    this.snCodeForm = this.$form.createForm(this);
  },
  mounted () {
    if (this.$route.query.id) {
      this.getDetail();
    }
  },
  methods: {
    /* 获取详情 */
    getDetail () {
      this.$get({
        url: `/smart_door_eq/${this.$route.query.id}`,
        params: {}
      }).then(({data}) => {
        this.actionList = data.action;
        for (let item in data) {
          this.loopSetVal(this.deviceInfoList, data, item);
        }

        let inputType = {enum: 'select', bool: 'switch', int: 'input', float: 'input'};
        let valueObj = {};
        let list = [];
        data.action.forEach((el, index) => {
          let label = el.setting_name;
          let type = el.setting_type;
          let propId = el.setting_id;
          let obj = {
            label: label,
            inputType: inputType[type],
            options: [],
            placeholder: '',
            extra: '',
            props: [`${propId}`]
          };
          valueObj[`${propId}`] = el.setting_val;
          let valContent = JSON.parse(el.setting_val_content);
          if (type === 'enum') {
            let option = [];
            valContent.forEach((el) => {
              for (let item in el) {
                option.push({ label: item, value: el[item] });
              }
            });
            obj.options = option;
            obj.placeholder = `请选择${label}`;
            obj.props[1] = {rules: [{required: true, message: `请选择${label}`}]};
          }

          if (type === 'int' || type === 'float') {
            let extra = this.generateExtra(valContent, el.setting_unique);
            obj.options = [];
            obj.placeholder = `${label}`;
            obj.min = parseFloat(valContent.min);
            obj.max = parseFloat(valContent.max);
            obj.extra = extra;
            obj.props[1] = {
              validateTrigger: 'blur',
              rules: [
                {required: true, message: `请输入${label}`}
              ]
            };
          }

          if (type === 'bool') {
            let settingVal = el.setting_val;
            if (settingVal) {
              let arr = [];
              for (let item in valContent) {
                if (settingVal === valContent[item]) {
                  if (item === 'open') {
                    valueObj[`${propId}`] = true;
                  } else {
                    valueObj[`${propId}`] = false;
                  }
                }
                arr.push(valContent[item]);
              }
              if (arr.indexOf(settingVal) < 0) { // 设置的值不在范围内 =》为false
                valueObj[`${propId}`] = false;
              }
            } else { // 没置值默认 =》为false
              valueObj[`${propId}`] = false;
            }
            obj.options = [];
            obj.placeholder = ``;
            obj.props[1] = {
              valuePropName: 'checked',
              rules: [{required: true, message: `请选择${label}`}]
            };
          }
          list.push(obj);
        });
        valueObj = {...valueObj, door_eq_name: data.device_name};
        this.functionList = list;
        this.$nextTick(() => {
          this.form.setFieldsValue(valueObj);
        });
      });
    },
    loopSetVal (target, data, item) {
      target.forEach((el) => {
        if (el.key === item) {
          el.value = data[item];
        }
      });
    },
    /* 打开弹窗 */
    openModal () {
      this.visible = true;
      this.deviceInfoList.forEach((el) => {
        if (el.key === 'device_sncode') {
          let values = {[el.key]: el.value};
          this.$nextTick(() => {
            this.snCodeForm.setFieldsValue(values);
          });
        }
      });
    },
    /* 替换设备编码 */
    changeSnCode () {
      this.snCodeForm.validateFields((err, values) => {
        if (err) { return; }
        this.snCode = values;
        let newValues = {...values};
        let name = this.form.getFieldsValue(['door_eq_name']);
        newValues = {...newValues, ...name};
        this.formSubmit(newValues);
      });
    },
    /* 提交表单 */
    handleSubmit () {
      this.form.validateFields((err, values) => {
        if (err) { return; }
        let arr = [];
        let newValues = {};
        for (let item in values) {
          if (item !== 'door_eq_name' && item !== 'device_sncode') {
            if (typeof values[item] === 'boolean') {
              this.actionList.forEach((el) => {
                if (el.setting_id.toString() === item) {
                  let content = JSON.parse(el.setting_val_content);
                  values[item] === true ? values[item] = content['open'] : values[item] = content['close'];
                }
              });
            }
            arr.push({ [item]: values[item] });
          } else {
            newValues[item] = values[item];
          }
        }
        arr = JSON.stringify(arr);
        newValues.action = arr;
        if (this.snCode) {
          newValues = {...newValues, ...this.snCode};
        } else {
          delete newValues.device_sncode;
        }
        this.formSubmit(newValues);
      });
    },
    formSubmit (param) {
      this.$put({
        url: `/smart_door_eq/${this.$route.query.id}`,
        params: param,
        btnLoading: this.btnLoading
      }).then((res) => {
        this.$store.commit('setOptData', true);
        this.visible = false;
        this.$message.success(`修改成功！`).then((res) => {
          this.$router.go(-1);
        });
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/device/smartDoor/editSmartDoor.vue